import { useMemo, useEffect, useState } from 'react';

import { useTaxIdConfig } from './use-tax-id-config';
import { getTaxData } from '../../../../services/tax-identifiers/api';

/** @typedef {import('../types/tax-types').TaxData} TaxData */
/** @typedef {import('../types/tax-types').InvoiceAddress} InvoiceAddress */
/** @typedef {import('../types/tax-types').UseTaxDataReturnType} UseTaxDataReturnType */

/**
 * @returns {UseTaxDataReturnType}
 */
export const useTaxData = () => {
  /**  @type {[TaxData, React.Dispatch<TaxData>]} */
  const [taxData, setTaxData] = useState({});
  const { isTaxIdAvailable } = useTaxIdConfig();

  useEffect(() => {
    if (!isTaxIdAvailable) return;

    const fetchData = async () => {
      try {
        const data = await getTaxData();
        setTaxData(data);
      } catch {
        setTaxData(null);
      }
    };
    fetchData();
  }, [isTaxIdAvailable, setTaxData]);

  return useMemo(
    () => ({
      taxData,
      setTaxData,
      isTaxDataAvailable: !!taxData?.taxIdentifier,
    }),
    [taxData],
  );
};
